// extracted by mini-css-extract-plugin
export default {"notesText":"AutoExpandingTextarea_notesText__UKeKb"};